import { GetServerSideProps } from 'next';
import { Fragment } from 'react';

import { wrapper } from 'src/redux/store/store';
import { Page } from 'src/__generated__/graphqlTypes';
import { getAboutPage } from 'src/api/pageApi';
import { setPages } from 'app-redux/actions/pageActions';
import { calculateCustomerType } from 'lib/session.service';
import { ServerSideRenderingContext } from 'types/objectTypes';
import { setAuthenticatedState } from 'app-redux/actions/authActions';
import { setOAPlatform } from 'app-redux/actions/appActions';
import { CustomerType } from 'constants/enums';
import { extractSlug, recognizeOAPlatform } from 'lib/page.service';
import withMiddleware, { commonMiddleware, postCommonMiddleware } from 'src/shared/lib/middleware/combiner';
import { setDefaultCacheBehavior } from 'lib/storage.service';
import { setSessionWithHashedId } from 'src/shared/lib/server/auth';

const handler = async ({
  // @ts-ignore
  locale,
  path,
  req,
  res,
  store,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  const session = req?.session?.getSession();
  const customerType = calculateCustomerType(req.session);

  const isAuthorized = customerType === CustomerType.EC;
  try {
    const slug = extractSlug(req.url, locale);

    if (!slug) {
      return { notFound: true };
    }

    const page = await getAboutPage({ slug, customerType, preview, path });

    if (page) {
      store.dispatch(setPages<Page>({ key: slug, value: page }));
      store.dispatch(setAuthenticatedState(isAuthorized));
      setSessionWithHashedId(store, session);
      const oaPlatform = recognizeOAPlatform(req.headers);
      store.dispatch(setOAPlatform(oaPlatform));
      setDefaultCacheBehavior(120, res);

      return { props: { } };
    }

    return { props: { } };
  } catch (e) {
    console.error(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(
    handler,
    { prior: commonMiddleware, post: postCommonMiddleware },
  ));

export default Fragment;
